import { useState } from "react";
import "../../styles/Contactinfo.css";

export default function ContactInfo({ isOpen, onClose, onSubmit }) {
  const [email,         setEmail]         = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [address,       setAddress]       = useState("");
  const [gstNumber,     setGstNumber]     = useState("");
  if (!isOpen) return null;
  function handleSubmit() {
    onSubmit?.({ email, contactNumber, address, gstNumber });
    onClose?.();
  }
  function handleBackdrop(e) {
    if (e.target === e.currentTarget) onClose?.();
  }
  return (
    <div className="ci-backdrop" onMouseDown={handleBackdrop}>
      <div className="ci-modal">
        {/* Title */}
        <h2 className="ci-title">Contact info</h2>
        {/* Subtitle */}
        <p className="ci-subtitle">
          Please add this information as this will show in the invoice
        </p>
        {/* Email */}
        <div className="ci-field">
          <label className="ci-label">Email</label>
          <input
            type="email"
            className="ci-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        {/* Contact number */}
        <div className="ci-field">
          <label className="ci-label">Contact number</label>
          <input
            type="tel"
            className="ci-input"
            value={contactNumber}
            onChange={(e) => setContactNumber(e.target.value)}
          />
        </div>
        {/* Address */}
        <div className="ci-field">
          <label className="ci-label">Address</label>
          <input
            type="text"
            className="ci-input"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </div>
        {/* GST Number */}
        <div className="ci-field">
          <label className="ci-label">Gst Number</label>
          <input
            type="text"
            className="ci-input"
            value={gstNumber}
            onChange={(e) => setGstNumber(e.target.value)}
          />
        </div>
        {/* Submit */}
        <button className="ci-submit-btn" onClick={handleSubmit}>
          SUBMIT
        </button>
        {/* Close */}
        <div className="ci-close-row">
          <button className="ci-close-btn" onClick={onClose}>CLOSE</button>
        </div>
      </div>
    </div>
  );
}